module.exports = __webpack_public_path__ + "img/t4.8c4e70bc.svg";